import { Achievements, H3, P } from "@sorcery/ui";

import { UserFollowers } from "~/components/organisms/user/UserFollowers";
import { UserFollowing } from "~/components/organisms/user/UserFollowing";
import type { UserPageType } from "~/types/user";

export const RenownTab = ({ isThisUser, user }: { isThisUser: boolean; user: UserPageType }) => {
  return (
    <div className="mb-8 w-full duration-700 animate-in fade-in">
      <div className="mb-6">
        <H3 className="!mb-2 !font-extrabold">Followers ({user.followers.length})</H3>
      </div>
      {isThisUser && <UserFollowers user={user} />}
      <div className="mb-6">
        <H3 className="!mb-2 !font-extrabold">Following ({user.following.length})</H3>
      </div>
      {isThisUser && <UserFollowing user={user} />}
      <H3 className="!mb-2 !font-extrabold">Achievements ({user.badges.length})</H3>
      {isThisUser &&
        (user.badges.length === 0 ? (
          <>
            <P className="!mb-1">None yet...</P>
            <P>
              Your Sorcery TCG achievements will appear here as you hone your deckbuilding skills,
              open product, compete with others, and engage with the community.
            </P>
          </>
        ) : (
          <Achievements badges={user.badges} />
        ))}
    </div>
  );
};
